import { formatShortMonthYear } from "@/composables/formatUtils";
import { getIssuanceStatusBadgeClass } from "@/dashboard/production_strategy/issuance-reporting/issuanceStatusUtils";

/**
 * Gets the badge class for any status (upload or issuance).
 * Combines upload result statuses and issuance record statuses.
 */
export function getStatusBadgeClass(status: string): string {
  const uploadClasses: Record<string, string> = {
    created: "bg-success",
    updated: "bg-primary",
    skipped: "bg-secondary",
  };

  const lowerStatus = status.toLowerCase();
  if (lowerStatus in uploadClasses) {
    return uploadClasses[lowerStatus];
  }

  return getIssuanceStatusBadgeClass(status);
}

/**
 * Formats MWh values to 3 decimal places.
 */
export function formatMwh(value: number | string): string {
  return Number(value).toFixed(3);
}

/**
 * Formats a date string to "MMM YYYY" format (e.g., "Nov 2025").
 */
export const formatPeriod = formatShortMonthYear;
